import { render, staticRenderFns } from "./SendMsg.vue?vue&type=template&id=8a76d73e&scoped=true&"
import script from "./SendMsg.vue?vue&type=script&lang=js&"
export * from "./SendMsg.vue?vue&type=script&lang=js&"
import style0 from "./SendMsg.vue?vue&type=style&index=0&id=8a76d73e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a76d73e",
  null
  
)

export default component.exports